// FE lang-key resolution for the notification-management surface.
//
// The API (C17) returns `message` as a lang key, not display copy — e.g.
// "notifications.coverage_rule_forbidden". There is no i18n/useLang system in
// this repo yet (checked: none exists under src/newui), so — following the
// existing precedent for server lang-key display used elsewhere in the RBAC
// surfaces (a LAST_SYSTEM_ADMIN_CODE/_FALLBACK pair) — known keys are mapped
// to copy here; an unrecognised key falls back to generic copy rather than
// ever rendering the raw key to the user.
export const COVERAGE_RULE_FORBIDDEN_KEY = "notifications.coverage_rule_forbidden";
export const COVERAGE_VIOLATION_KEY = "notifications.coverage_violation";

const NOTIFICATION_LANG_MAP: Record<string, string> = {
	[COVERAGE_RULE_FORBIDDEN_KEY]:
		"This rule is not allowed — it would silence a coverage-guaranteed notification type for a bidder.",
	[COVERAGE_VIOLATION_KEY]:
		"This change would reduce a bidder organisation below its guaranteed notification coverage.",
};

const NOTIFICATION_LANG_FALLBACK = "This action could not be completed.";

export const resolveNotificationLangKey = (key: string | undefined | null): string => {
	if (!key) {
		return NOTIFICATION_LANG_FALLBACK;
	}

	return NOTIFICATION_LANG_MAP[key] ?? NOTIFICATION_LANG_FALLBACK;
};
